(() => {
  'use strict';

  const BUILD = 'v253';
  const root = document.documentElement;
  root.dataset.noahqBuild = BUILD;
  root.classList.remove(
    'noahq-font-stability-pending',
    'noahq-font-stability-ready',
    'noahq-font-cache-warm',
    'noahq-font-fallback-lock',
    'noahq-font-first-reveal',
    'noahq-font-css-pending',
    'noahq-font-css-ready'
  );

  function normalizeLegacyTypekitClasses() {
    root.classList.remove('wf-loading', 'wf-inactive');
  }

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const replaceTextIn = (container, search, replacement, firstOnly = false) => {
    if (!container || !search) return false;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let changed = false;

    while (walker.nextNode()) {
      const node = walker.currentNode;
      const value = node.nodeValue || '';
      if (!value.includes(search)) continue;

      node.nodeValue = value.replace(search, replacement);
      changed = true;
      if (firstOnly) break;
    }

    return changed;
  };

  function removeDuplicatePolicyHeading() {
    const title = document.querySelector('.shopify-policy__title h1, .shopify-policy__title h2');
    const body = document.querySelector('.shopify-policy__body');
    if (!title || !body) return;

    const titleText = normalize(title.textContent);
    const firstHeading = body.querySelector('h1, h2, h3');
    if (!firstHeading || normalize(firstHeading.textContent) !== titleText) return;

    firstHeading.hidden = true;
    firstHeading.setAttribute('data-noahq-duplicate-policy-heading', '');
    firstHeading.setAttribute('aria-hidden', 'true');
  }

  function patchPublishedPrivacyCopy() {
    if (!location.pathname.includes('/policies/privacy-policy')) return;

    const body = document.querySelector('.shopify-policy__body');
    if (!body) return;

    const correctionItem = Array.from(body.querySelectorAll('li')).find((item) => {
      const text = normalize(item.textContent);
      return text.startsWith('訂正権') && text.includes('個人情報の削除をリクエストする権利');
    });

    if (correctionItem) {
      replaceTextIn(
        correctionItem,
        '当社が保有するお客様の個人情報の削除をリクエストする権利',
        '当社が保有するお客様の個人情報が不正確である場合、その訂正をリクエストする権利',
        true
      );
    }

    const contactCandidates = Array.from(body.querySelectorAll('p, li')).filter((element) => {
      const text = normalize(element.textContent);
      return text.includes('info@yj-fashion.com') || text.includes('プライバシー慣行');
    });
    const contactRoot = contactCandidates[0] || body;

    const contactWalker = document.createTreeWalker(contactRoot, NodeFilter.SHOW_TEXT);
    const contactNodes = [];
    while (contactWalker.nextNode()) contactNodes.push(contactWalker.currentNode);

    contactNodes.forEach((node) => {
      let value = node.nodeValue || '';

      if (value.includes('までお電話いただくか') && !value.includes('052-433-2526までお電話いただくか')) {
        value = value.replace(/\s*までお電話いただくか/, '052-433-2526までお電話いただくか');
      }

      if (value.includes('熱田区千年2丁目31-11, 名古屋市, JP-23, 456-0054, JP')) {
        value = value.replace(
          '熱田区千年2丁目31-11, 名古屋市, JP-23, 456-0054, JP',
          '〒456-0054 愛知県名古屋市熱田区千年2丁目31-11まで郵送でご連絡ください。'
        );
      }

      node.nodeValue = value;
    });
  }

  function cleanDuplicateCardAccessibility() {
    document.querySelectorAll('.card.card--media').forEach((card) => {
      const headings = card.querySelectorAll('.card__heading');
      if (headings.length < 2) return;

      const first = headings[0];
      const second = headings[headings.length - 1];
      if (normalize(first.textContent) !== normalize(second.textContent)) return;

      first.setAttribute('aria-hidden', 'true');
      first.querySelectorAll('a, button, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
        element.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function improveBlankCardImageAlternatives() {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      const headings = card.querySelectorAll('.card__heading');
      const cardTitle = normalize(headings[headings.length - 1]?.textContent);
      if (!cardTitle) return;

      card.querySelectorAll('.card__media img').forEach((image, index) => {
        if (normalize(image.getAttribute('alt'))) return;
        image.setAttribute('alt', `${cardTitle} 商品画像 ${index + 1}`);
      });
    });
  }

  function cleanHeroLinkQuotes() {
    document.querySelectorAll('.noahq-hero__linkrow a').forEach((link) => {
      const text = normalize(link.textContent);
      const match = text.match(/^「(.+)」$/);
      if (match) link.textContent = match[1];
    });
  }

  function suppressDuplicateHomepageFooter() {
    if (!root.classList.contains('noahq-page-index')) return;
    const footerGroup = document.querySelector('.shopify-section-group-footer-group');
    if (!footerGroup) return;

    footerGroup.hidden = true;
    footerGroup.setAttribute('aria-hidden', 'true');
  }

  function normalizeHomepageHeadingStructure() {
    if (!root.classList.contains('noahq-page-index')) return;

    const headerHeading = document.querySelector('header .header__heading');
    const mainHeading = document.querySelector('#MainContent h1');
    if (!headerHeading || !mainHeading || headerHeading.tagName !== 'H1') return;

    const replacement = document.createElement('div');
    Array.from(headerHeading.attributes).forEach((attribute) => {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    while (headerHeading.firstChild) replacement.appendChild(headerHeading.firstChild);
    headerHeading.replaceWith(replacement);
  }

  function markCurrentDesktopNavigation() {
    const path = location.pathname.replace(/\/+$/, '') || '/';

    document.querySelectorAll('.noahq-art-header-nav a').forEach((link) => {
      link.removeAttribute('aria-current');
      const href = link.getAttribute('href') || '';
      let current = false;

      if (href === '/' || href === location.origin || href === `${location.origin}/`) {
        current = path === '/';
      } else if (href.includes('#noahq-buzz')) {
        current = path === '/' && location.hash === '#noahq-buzz';
      } else if (href.includes('/collections/')) {
        current = path.startsWith('/collections/') || path.startsWith('/products/');
      } else if (href.includes('/blogs/news')) {
        current = path.startsWith('/blogs/news');
      } else if (href.includes('/pages/contact')) {
        current = path === '/pages/contact';
      }

      if (current) link.setAttribute('aria-current', 'page');
    });
  }

  function removePoweredByShopify() {
    document.querySelectorAll('.footer__copyright .copyright__content').forEach((item) => {
      const link = item.querySelector('a[href*="shopify.com"]');
      const text = normalize(item.textContent).toLowerCase();
      if (link || text.includes('powered by shopify')) item.remove();
    });
  }

  function improveFormAnnouncements() {
    document.querySelectorAll('.newsletter-form__message--success, .noahq-form-message').forEach((message) => {
      if (!message.hasAttribute('role')) message.setAttribute('role', 'status');
      if (!message.hasAttribute('aria-live')) message.setAttribute('aria-live', 'polite');
    });

    document.querySelectorAll('.newsletter-form__message:not(.newsletter-form__message--success), .form-status[role="alert"]').forEach((message) => {
      message.setAttribute('role', 'alert');
      message.setAttribute('aria-live', 'assertive');
    });
  }




  function secureExternalLinks() {
    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', Array.from(rel).join(' '));
    });
  }

  function runAuditHardening() {
    normalizeLegacyTypekitClasses();
    removeDuplicatePolicyHeading();
    patchPublishedPrivacyCopy();
    cleanDuplicateCardAccessibility();
    improveBlankCardImageAlternatives();
    cleanHeroLinkQuotes();
    suppressDuplicateHomepageFooter();
    normalizeHomepageHeadingStructure();
    markCurrentDesktopNavigation();
    removePoweredByShopify();
    improveFormAnnouncements();
    secureExternalLinks();
  }

  onReady(runAuditHardening);
  document.addEventListener('shopify:section:load', runAuditHardening);
})();
